// extracted by mini-css-extract-plugin
var _1 = "GarminInformationalModal-module__container___nYnlA";
var _2 = "GarminInformationalModal-module__img___MCb7U";
var _3 = "GarminInformationalModal-module__title___nsRcv";
export { _1 as "container", _2 as "img", _3 as "title" }
